module.exports = __webpack_public_path__ + "img/shipped (3).5341a664.png";